import styles from "./Supports.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { IStaffItem } from "../../../models/Staff";
import StaffEmpty from "../StaffEmpty/StaffEmpty";
import StaffItem from "../StaffItem/StaffItem";
import { StaffService } from "../../../services/staff.service";
import { useGetAllSupportsQuery } from "../../../api/queries";

const Supports = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [searchValue, setSearchValue] = useState<string | null>(null);
  const { data: supportList = [], refetch } = useGetAllSupportsQuery(searchValue);

  useEffect(() => {
    if (location.search) {
      const searchParams = new URLSearchParams(location.search);
      const shouldUpdate = searchParams.get("shouldUpdate");
      if (searchParams.get("searchValue") !== searchValue) {
        setSearchValue(searchParams.get("searchValue"));
      }
      if (shouldUpdate) {
        refetch();
      }
      navigate("/staff/supports");
    }
  }, [location]);

  if (!supportList.length) {
    return <StaffEmpty activeTab={"support"} />;
  }

  return (
    <div className={styles.wrapper}>
      {supportList.length &&
        supportList.map((el) => {
          return <StaffItem key={el.id} data={el} activeTab={"support"} />;
        })}
    </div>
  );
};

export default Supports;
